import { BoxProps, ButtonGroup } from '@mui/material'
import styled from 'styled-components'

interface BtnGroupProps extends BoxProps {
  isRoadMap?: boolean
}

export const BtnGroupZoom = styled(ButtonGroup).withConfig<BtnGroupProps>({
  shouldForwardProp: (prop) => prop !== 'isRoadMap',
})`
  position: absolute;
  bottom: 15px;
  left: 50%;
  transform: translateX(-50%);
  background: ${(props) =>
    props.isRoadMap ? 'rgba(142, 145, 143, 0.555)' : '#FFFFFF33'};
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25),
    0px 0px 8px 0px rgba(255, 255, 255, 0.2) inset,
    0px 0px 12px 0px rgba(0, 0, 0, 0.1);
  border-radius: 100px;
  padding: 7px 10px;
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);

  .MuiButtonGroup-grouped {
    padding: 5px;
    height: 20px;
    min-width: 30px;
    font-weight: 500;
    font-size: 13px;
    line-height: 18px;
    border-radius: 50%;
    margin: 1px;
    padding-top: 8px;
    &:not(:last-of-type) {
      border-right: none;
    }
    &.MuiButton-contained {
      color: #ffffff;
    }
    background-color: transparent;
    border: none;
  }
`

export default BtnGroupZoom
